import { Theme, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { JOBS_HEADER } from 'shared/constants/ASSETS_URL';

export const HeaderCont = styled('div')<Theme, { shrink: number }>(({ theme, shrink }) => ({
  backgroundColor: 'rgba(27, 35, 45, 0.86)',
  height: shrink ? 60 : 230,
  transition: '300ms ease-in-out',
  padding: '10px 20px',
  display: 'flex',
  flexDirection: 'column',
  // backgroundImage: 'linear-gradient(to right, rgb(255 255 255 / 0%), rgb(230 230 230 / 19%))',
  backgroundImage: shrink
    ? 'linear-gradient(to right, rgb(255 255 255 / 0%), rgb(230 230 230 / 19%))'
    : `url(${JOBS_HEADER})`,
  backgroundPositionY: '-2px',
  [theme.breakpoints.down('sm')]: {
    height: 60,
    padding: '0px 20px',
  },
  position: 'relative',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

export const MainHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const Logo = styled('img')(({ theme }) => ({
  objectFit: 'contain',
  height: 35,
  alignSelf: 'center',
}));

export const ButtonCont = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 20,
}));

export const JobText = styled(CustomTypography)(({ theme }) => ({
  backgroundImage: 'linear-gradient(to right, #98c7ff, #fff)',
  fontFamily: 'HelveticaNeue',
  fontSize: 40,
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.46',
  letterSpacing: 'normal',
  textAlign: 'left',
  '-webkit-background-clip': 'text',
  backgroundClip: 'text',
  '-webkit-text-fill-color': 'transparent',
}));

export const TextCont = styled('div')<Theme, { shrink: number }>(({ theme, shrink }) => ({
  marginTop: 'auto',
  opacity: shrink ? 0 : 1,
  transition: `${shrink ? '100' : '1000'}ms ease-in-out`,
  position: 'absolute',
  bottom: 35,
}));

export const HeaderItem = styled(CustomTypography)<Theme, { primary: number; disabled?: number }>(
  ({ theme, primary, disabled }) => ({
    color: primary ? COLORS.PRIMARY : 'white',
    maxWidth: 800,
    fontSize: 14,
    cursor: disabled ? 'not-allowed' : 'pointer',
    //add hover effect
    '&:hover': {
      color: disabled ? COLORS.WHITE : COLORS.PRIMARY,
    },
    transition: 'color 300ms ease-in-out',
  }),
);
